import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { ChapterAuthenticated } from '../components/chapter/ChapterAuthenticated';
import { ChapterUnauthenticated } from '../components/chapter/ChapterUnauthenticated';
import { SEOHead } from '../components/common';

export const Chapter: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const { bookSlug, chapterNumber } = useParams<{
    bookSlug: string;
    chapterNumber: string;
  }>();

  return (
    <>
      <SEOHead
        title={t('chapter_title', {
          chapter: chapterNumber,
          book: bookSlug?.replace(/[-_]/g, ' '),
        })}
        description={t('chapter_description', {
          chapter: chapterNumber,
          book: bookSlug?.replace(/[-_]/g, ' '),
        })}
        canonical={`/books/${bookSlug}/chapter/${chapterNumber}`}
        ogType="article"
      />
      {isAuthenticated ? <ChapterAuthenticated /> : <ChapterUnauthenticated />}
    </>
  );
};
